import axios from 'axios';
import api from './AppReq';

export default axios.create({
    baseURL: `${api.defaults.baseURL}app/notification`
})